const initialState = {
  isLoading: false,
};

/**
 * spinnerReducer: Reducer to manage the loading state for the spinner.
 * @param {any} state - The current state of the spinner.
 * @param {any} action - The action to be processed.
 * @returns {any} - The updated state based on the action type.
 */

const spinnerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_LOADING_STATE":
      return { isLoading: action?.payload };
      break;
    default:
      return state;
  }
};

export default spinnerReducer;
